import React, { useState, useEffect, useRef } from "react";
import { Row, Col , Table } from "antd";
import GameScene from "../components/game-scene";
import "antd/dist/reset.css"; // reset Antd styles for easier custom overrides
import { WinDisplay } from "../components/win-display";
import { BalanceBar, GameSummaryBar, HamburgerMenu, BetHistory } from "../components/header";
import { HamburgerIcon } from "../components/header";
import { BetComponent } from "../components/bet";
import { playBgMusic, stopBgMusic } from "../utils/audio";
import { playBajajSound, stopBajajSound } from "../utils/audio";
import { NotEnoughBalanceModal } from "../components/win-display";
import { getLocalData } from "../utils/storage";
import { connectToWebSocket, sendMessageToWebSocket, closeWebSocket, onMessage } from "../services/ws-config";
import BajajLogo from "../assets/bajaj_logo.png";




function MainGame() {
  // Simulated values
  const [multiplier, setMultiplier] = useState(1.00);
  const [cashoutMultiplier, setCashoutMultiplier] = useState(1.00);
  const [payouts, setPayouts] = useState(12654);
  const [winners, setWinners] = useState(32);
  const [menuOpen, setMenuOpen] = useState(false);
  const [betHistoryOpen, setBetHistoryOpen] = useState(false);
  const [winDisplayOpen, setWinDisplayOpen] = useState(false);
  const [startGame, setStartGame] = useState(false);
  const [betAmount, setBetAmount] = useState(50);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [balance, setBalance] = useState(100000);
  const [balanceDisplayOpen, setBalanceDisplayOpen] = useState(false);
  const [totalWin, setTotalWin] = useState(0);
  const [isCrashed, setIsCrashed] = useState(false);
  const [crashedMultiplier, setCrashedMultiplier] = useState(0);
  const [betHistory, setBetHistory] = useState([]);
  const [crashMultiplier, setCrashMultiplier] = useState(1.00);

  const [musicOn, setMusicOn] = useState(false);
  const [audioOn, setAudioOn] = useState(false);
  

  const bgMusicRef = useRef(null);


  // Fake multiplier animation
  useEffect(() => {
    if (startGame) {
      setIsCrashed(false);
      playBajajSound();

      let i = 80;
      const interval = setInterval(() => {
        setMultiplier(m => {
          const newMultiplier = m + 0.01;
          return newMultiplier;
        });
      }, i);
        return () => clearInterval(interval);
    }
    else{
      
      stopBajajSound(); 
      setMultiplier(1.00);
      
    }
  }, [startGame]);


  useEffect(() => {
    if(multiplier > crashMultiplier && !isCrashed){
      setCrashedMultiplier(multiplier);
      setIsCrashed(true);
      setTimeout(() => {
        setStartGame(false);
        setIsCrashed(false);
        setBetHistory([...betHistory, {date: new Date().toLocaleString(), bet: betAmount, multiplier: multiplier , win: 0}]);
      
        
      }, 1000);
      
    }
  }, [multiplier]);

  useEffect(() => {
    //connectToWebSocket();
    const handleVisibilityChange = () => {
      if (document.hidden) {
        stopBgMusic();
        stopBajajSound();
      } else {
        const musicOn = getLocalData('musicOn')?.musicOn;
        const soundOn = getLocalData('soundOn')?.soundOn;
        if (musicOn !== false) {
          playBgMusic();
        }
        if (soundOn !== false && startGame) {
          playBajajSound();
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
 
  
  /*useEffect(() => {
    onMessage((event) => {
      console.log('Message from WebSocket:', event.data);
    });
  }, []);*/


  useEffect(() => {
    const handleClick = () => {
      if(musicOn){
        playBgMusic();
      }
    };
    
    document.addEventListener('click', handleClick);
    
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);



  
  

  return (
    <div className="main-game-bg" >
      {balanceDisplayOpen && (
       <NotEnoughBalanceModal open={balanceDisplayOpen} onClose={() => setBalanceDisplayOpen(false)} />
      )}
      {/* Hamburger menu */}
      <div className="abs-left-top">
      
        <div style={{ display: "flex", alignItems: "center" }}>
          <HamburgerIcon style={{ width: "20px", height: "20px" , zIndex: 10000 }} onClick={() => setMenuOpen(true)} />
          <HamburgerMenu  musicOn={musicOn} audioOn={audioOn} setMusicOn={setMusicOn} setAudioOn={setAudioOn} open={menuOpen} onClose={() => setMenuOpen(false)} setMenuOpen={setMenuOpen} betHistoryOpen={betHistoryOpen} setBetHistoryOpen={setBetHistoryOpen} />
          <BetHistory open={betHistoryOpen} onClose={() => setBetHistoryOpen(false)} betHistory={betHistory} />
          <WinDisplay open={winDisplayOpen} onClose={() => setWinDisplayOpen(false)} amount={(cashoutMultiplier * betAmount)} multiplier={cashoutMultiplier} />
          <img src={BajajLogo} alt="Bajaj Logo" style={{ width: "60px" , marginLeft: "10px" }} />
        </div>
      </div>
      
      {/* Game summary on top right */}
      <div className="abs-right-top">
        {/* <GameSummaryBar payouts={payouts} winners={winners} /> */}
        <BalanceBar balance={balance} />
      </div>
      {/* Game scene */}
      <GameScene multiplier={multiplier} isCrashed={isCrashed} crashMultiplier={10} play = {startGame} />
      {/* Multiplier in center */}
      {(startGame) && (
      <div className="center-multiplier">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <span 
            className="multiplier-label" 
            style={{
              color: isCrashed ? 'red' : multiplier >= 4 ? 'brown' : multiplier >= 2 ? 'orange' : '#fff'
            }}
          >
            {(isCrashed ? 'BAJAJ LEFT' : (multiplier * betAmount).toFixed(2) + ' Br')}  
          </span>
          <span 
            className="multiplier-label" 
            style={{
              color: isCrashed ? 'red' : multiplier >= 4 ? 'brown' : multiplier >= 2 ? 'orange'  : '#fff'
            }}
          >
            {(isCrashed ? crashedMultiplier.toFixed(2) : multiplier.toFixed(2)) + 'x'}
          </span>
        </div>
      </div>
      )}
      {/* Bet at bottom */}
      <div className="abs-bottom-center">
        <Row style={{ width: "100%"}}>
            <Col xs={0} sm={0} md={2} lg={5} xl ={5} xxl={7}>
            </Col>
            <Col xs={24} sm={24} md={20} lg={14} xl={14} xxl={10}>
                <BetComponent winDisplayOpen={winDisplayOpen} setWinDisplayOpen={setWinDisplayOpen}
                 multiplier={multiplier} setMultiplier={setMultiplier} setCashoutMultiplier={setCashoutMultiplier} startGame={startGame} setStartGame={setStartGame} betAmount={betAmount} setBetAmount={setBetAmount}
                 balanceDisplayOpen={balanceDisplayOpen} setBalanceDisplayOpen={setBalanceDisplayOpen} balance={balance} setBalance={setBalance} 
                 totalWin={totalWin} setTotalWin={setTotalWin} 
                 isCrashed={isCrashed}  
                 betHistory={betHistory}
                 setBetHistory={setBetHistory}
                 crashMultiplier={crashMultiplier}
                 setCrashMultiplier={setCrashMultiplier}
                 />
                
            </Col>
        </Row>
        
      </div>
    </div>
  );
}

export default function MainPage() {
  return (
    <div className="aviator-main-root">
      <MainGame />
      <style>{`
        .aviator-main-root {
          background: #161618;
          min-height: 100vh;
          min-width: 100vw;
          color: white;
          font-family: 'Orbitron', sans-serif;
          position: relative;
        }
        .splash-screen {
          display: flex;
          position:fixed;
          inset:0;
          background: #131215;
          align-items:center;
          justify-content:center;
        }
        .splash-content {
          text-align: center;
        }
        .splash-logo {
          font-size: 64px;
          margin-bottom:20px;
        }
        .splash-title {
          font-size: 2.5rem;
          letter-spacing: 3px;
          color: white;
          font-weight: bold;
          margin-bottom: 8px;
        }
        .splash-desc {
          color: #bbb;
        }
        .main-game-bg {
          position:relative;
          min-height: 100vh;
          min-width: 100vw;
          background: #161618;
        }
        .abs-left-top {
          position:absolute;
          left:32px;
          top:32px;
          z-index:1000;
          align-items:center;
          justify-content:center;
        }
        .abs-right-top {
          position:absolute;
          right:32px;
          top:32px;
          z-index:10;
        }
        .center-multiplier {
          display:flex;
          align-items:center;
          justify-content:center;
          min-height: 72vh;
          z-index: 10;
          position: relative;
        }
        .multiplier-label {
          font-size: clamp(3.5rem, 8vw, 5rem);
          color: #FFF;
          text-shadow:0 0 18px #fff4;
          font-weight: 800;
          letter-spacing: 1.5px;
          align-items:center;
          justify-content:center;
          text-align:center;
        }
        .game-summary {
          background: rgba(34,34,34,0.85);
          padding: 17px 24px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          gap: 12px;
          box-shadow: 0 1px 18px rgba(0,0,0,0.15);
        }
        .game-summary .summary-label {
          font-size:0.8rem;
          opacity:0.7;
        }
        .game-summary .summary-value {
          font-size:1.1rem;
          font-weight:bold;
          margin-right: 8px;
        }
        .game-summary .winners {
          margin-left: 12px;
        }

        .balance-bar {
          background: rgba(34,34,34,0.85);
          padding: 12px 24px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          z-index: 10;
          gap: 4px;
          box-shadow: 0 1px 18px rgba(0,0,0,0.15);
        }
        .balance-bar .balance-label {
          font-size:0.8rem;
          opacity:0.7;
        }
        .balance-bar .balance-value {
          font-size:1rem;
          font-weight:bold;
          margin-right: 3px;
        }
        
        /* Responsive overrides for new bottom bet bar */
        .abs-bottom-center {
          position: absolute;
          left: 0%;
          bottom: 0;
          
          z-index: 9;
          width: 100%;
          max-width: 100%;
        }
        @media (max-width:700px) {
          .abs-bottom-center {
            left:0 !important;
            width:100vw !important;
            max-width:100% !important;
          }
        }

        .hamburger {
          background:none;
          border:none;
          cursor:pointer;
          padding:0;
        }
        .modal-backdrop {
          position:fixed;
          left:0;top:0;right:0;bottom:0;
          background:rgba(0,0,0,0.45);
          z-index:99;
          display:flex;
          align-items:flex-start;
          justify-content:flex-start;
        }
        .modal-content {
          background:#191419;
          border-radius: 16px;
          min-width:270px;
          padding:24px 32px 28px 17px;
          margin: 45px 0 0 37px;
          color: white;
          box-shadow: 0 3px 22px #0006;
        }
        .hamburger-menu h3 {
          font-size:1.25rem;
          margin-bottom:18px;
          color:#d0f6d9;
        }
        .menu-switch {
          display:flex;
          align-items:center;
          justify-content:space-between;
          margin-bottom: 16px;
        }
        .toggle-btn {
          background: #242c36;
          color: #bbb;
          border: none;
          font-weight:700;
          border-radius:8px;
          padding:6px 19px;
          font-size:1rem;
          cursor:pointer;
          margin-left:12px;
        }
        .toggle-btn.on {
          background: #37cd5a;
          color: #fff;
        }
        .menu-list {
          margin-top: 16px;
        }
        .menu-link {
          background: #232729;
          color: #fff;
          width: 100%;
          border: 1.5px solid #232729;
          border-radius: 8px;
          padding: 8px 24px;
          cursor:pointer;
          font-size:1rem;
          margin-bottom:7px;
          font-weight:600;
        }
      `}</style>
    </div>
  );
}

